import { createSlice, current } from "@reduxjs/toolkit";
import { v4 } from 'uuid'
// required:  define initial state for global module
export const globalInitialState = {
    modalData: null,
}

// required:  create slice for global module with required reducers (actions)
export const globaltSlice = createSlice({
    name: "global",
    initialState: globalInitialState,
    reducers: {
        setModalData: (state, action) => {
            state.modalData = action.payload;
        }
    },
});

// required: export all defined reducer functions as actions
export const {
    setModalData,
} = globaltSlice.actions;

// required: export complete reducer
export default globaltSlice.reducer;
